import {configureStore} from '@reduxjs/toolkit'
import userReducer from './userSlice'
import userRoleReducer from './userRoleSlice'
import kp11CartReducer from './kp11CartSlice'
import kpGlobalStateReducer from './kpGlobalStateSlice'
import KpCouponSliceReducer from './kp11CouponSlice'
import CcCouponSliceReducer from './coupon'
import productRulesReducer from './productRules/productRulesSlice'
import accountsReducer from './accounts/accountsSlice'
import accountSetupReducer from './AccountSetupSlice'
import catalogReducer from './CatalogSlice'
import orderSummaryReducer from './orderSummary/orderSummarySlice'
import proposalReducer from './ProposalSlice'
import purchaseLinkReducer from './PurchaseLinkSlice'

const appStore = configureStore({
  reducer: {
    user: userReducer,
    userRole: userRoleReducer,
    kp11: kp11CartReducer,
    kpGlobalState: kpGlobalStateReducer,
    kpCouponState: KpCouponSliceReducer,
    ccCouponState: CcCouponSliceReducer,
    productRules: productRulesReducer,
    accounts: accountsReducer,
    accountSetup: accountSetupReducer,
    catalog: catalogReducer,
    orderSummary: orderSummaryReducer,
    proposal: proposalReducer,
    purchaseLink: purchaseLinkReducer,
  },
})

export default appStore
